import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { PageLoader } from '@/components/common/PageLoader'
import { AppProviders } from '@/app/providers'
import { router } from '@/app/router'

export function App() {
  return (
    <AppProviders>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </AppProviders>
  )
}
